module.exports = __webpack_public_path__ + "assets/hot.24d8c294.svg";